export enum HtmlContentType {
    TermsAndConditions = 0,
    Instructions = 1,
    TradeTerms = 2,
    ProtectionOfPersonalData = 3,
    Custom = 4,
    Unknown = 255     
}